export default __webpack_public_path__ + "static/media/icon.military gloves.c3a6699d.svg";